import { types } from 'mobx-state-tree';

import DamageClaimTypeValues from '../definitions/DamageClaimTypeValues';


export default types
    .model('DamageClaim', {
        id: types.identifier,
        type: types.enumeration(
            Object.values(DamageClaimTypeValues),
        ),
        date: types.string,
    });
